module.exports = __webpack_public_path__ + "static/card-neal-68d080ec44b0d9d9333c017150680ece.jpg";